import { ApplicationConfig, ErrorHandler } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.route';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient } from '@angular/common/http';
import { EmployeeService } from './core/services/employee.service';
import { AuthenticateService } from '@core/services/authenticate.service';
import { environment } from '../environments/environment';
import * as Sentry from '@sentry/angular-ivy';
import { KmapService } from '@core/services/kmap.service';

let providers: ApplicationConfig['providers'] = [
  provideRouter(routes),
  provideAnimations(),
  provideHttpClient(),
  EmployeeService,
  KmapService,
];

// TODO: create and use the mock services on `test`
if (environment.name === 'test') {
  providers = [
    ...providers,
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: true,
      }),
    },
    { provide: EmployeeService, useClass: EmployeeService },
    { provide: AuthenticateService, useClass: AuthenticateService },
    // TODO: replace with { provide: EmployeeService, useClass: EmployeeMockService }
    { provide: KmapService, useClass: KmapService },
  ];
}

export const appConfig: ApplicationConfig = {
  providers,
};
